import { useState } from 'react';
import {
  Box,
  Grid,
  Typography,
  Autocomplete,
  Button,
  Card,
  Stack,
  Popper,
} from '@mui/material';
import { CustomTextFieldNoBorders } from '../../components/customTextField';
import CloseLight from '../../Icons/closeLight';
import { specialtyFilters } from '../../constants/specialties_newest';
import { CircleButton } from './circleButton';

const textColor = '#212634';

const RemoveButton = (props) => {
  const { handleClick } = props;
  return (
    <div onClick={handleClick} style={{ cursor: 'pointer' }}>
      <CloseLight />
    </div>
  );
};

const getUserSpecialty = (spec) => {
  if (spec) {
    return (
      specialtyFilters
        .find((inco) => inco.name === spec)
        ?.subspecialties?.sort() || []
    );
  }
  return [];
};

const Selection = (props) => {
  const {
    selected,
    specialities,
    handleAddSubselection,
    removeSelection,
    removeSubSelection,
  } = props;
  const [selectedSub, setSelectedSub] = useState();

  const handleAddSubSpecialty = (value) => {
    setSelectedSub(value);
  };
  const handleAddSub = () => {
    if (selectedSub) {
      setSelectedSub();
      handleAddSubselection(selected.specialty, selectedSub);
    }
  };

  const subSpec = getUserSpecialty(selected?.specialty);
  // getSubSpec?.Subspecialty !== '' ? getSubSpec?.Subspecialty?.split(',') : [];
  return (
    <Card
      key={specialities}
      sx={{
        width: '100%',
        borderRadius: 0,
        border: '1px solid #E2E2E2',
        boxShadow: 'none',
      }}
    >
      <Box
        sx={{
          backgroundColor: '#D4EEDD',
          px: 3,
          py: 2,
          borderBottom: '1px solid #E2E2E2',
        }}
      >
        <Typography
          color={textColor}
          variant="h6"
          fontWeight="500"
          fontSize="14px"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {selected?.specialty} &nbsp; &nbsp;{' '}
          {
            <RemoveButton
              handleClick={() => removeSelection(selected.specialty)}
            />
          }
        </Typography>
      </Box>
      <Grid sx={{ mt: 0, mr: 2, p: 3 }} container direction="column">
        <Grid
          container
          direction="row"
          alignItems="center"
          gap={2}
          sx={{ border: '1px solid #E2E2E2', borderRadius: '4px' }}
        >
          <Grid item sx={{ flexGrow: 9 }}>
            <Autocomplete
              freeSolo
              id="subSubspecialties-auto-complete"
              options={subSpec}
              PopperComponent={({ style, ...props }) => (
                <Popper {...props} style={{ ...style, height: 0 }} />
              )}
              value={selectedSub || ''}
              ListboxProps={{ style: { maxHeight: '20vh' } }}
              onInputChange={(_event, value) =>
                handleAddSubSpecialty(value?.slice(0, 255))
              }
              sx={{
                width: '100%',
                color: 'black',
                p: 0,
              }}
              renderInput={(params) => (
                <CustomTextFieldNoBorders
                  value={selectedSub || ''}
                  {...params}
                  placeholder="Search for a subspecialty (Optional)"
                />
              )}
            />
          </Grid>
          <CircleButton onClick={() => handleAddSub()} />
        </Grid>
        <Grid container direction="column" gap={2} sx={{ mt: 2 }}>
          {selected?.sub.length ? (
            selected.sub.map((subSelection, index) => (
              <Card
                key={`${subSelection.specialty}-${index}`}
                sx={{
                  p: 1,
                  border: '1px solid #E2E2E2',
                  width: '100%',
                  boxShadow: 'none',
                  borderRadius: '0px',
                }}
              >
                <Grid
                  container
                  direction="row"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Typography
                    color={textColor}
                    gutterBottom
                    variant="body1"
                    sx={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'space-between',
                      alignItems: 'center',
                      margin: 0,
                    }}
                  >
                    {subSelection.specialty} &nbsp; &nbsp;{' '}
                  </Typography>
                  <RemoveButton
                    handleClick={() =>
                      removeSubSelection(
                        selected.specialty,
                        subSelection.specialty,
                      )
                    }
                  />
                </Grid>
              </Card>
            ))
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
    </Card>
  );
};

export default Selection;
